'use strict';

const workpackageTypes = {
  ASSORTMENT_FULL_RESET: 'a_full_reset',
  ASSORTMENT_SIMPLE_SWAPS: 'a_simple_swaps',
  ASSORTMENT_FRESH: 'a_fresh',
};

module.exports = {
  ...workpackageTypes,
  ALL: Object.values(workpackageTypes),
  // Standard workpackage types to follow the main workflow with minor differences
  STANDARD: [
    workpackageTypes.ASSORTMENT_FULL_RESET,
    workpackageTypes.ASSORTMENT_FRESH,
  ],
};
